import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { formatIndianCurrency, formatIndianGrouping, formatPct } from "@/lib/format";

function Delta({ value }) {
  if (value === null || value === undefined) return null;
  const pos = value >= 0;
  const Icon = pos ? ArrowUpRight : ArrowDownRight;
  return (
    <span className={`inline-flex items-center gap-1 font-mono text-[11px] ${pos ? "text-positive" : "text-destructive"}`}>
      <Icon className="w-3 h-3" />{formatPct(value, { signed: true })}
    </span>
  );
}

export default function KpiTile({ label, value, kind = "currency", deltas = [], sub, testId, accent }) {
  const display = (() => {
    if (value === undefined || value === null) return "—";
    if (kind === "currency") return formatIndianCurrency(value);
    if (kind === "number") return formatIndianGrouping(value);
    if (kind === "pct") return formatPct(value);
    return String(value);
  })();

  // Auto-shrink long strings (e.g., "₹61.42 L") so they never wrap
  const len = display.length;
  const numCls =
    len > 10 ? "text-[22px] md:text-[28px] lg:text-[32px]" :
    len > 7  ? "text-[26px] md:text-[34px] lg:text-[40px]" :
               "text-[28px] md:text-[40px] lg:text-[48px]";

  return (
    <div data-testid={testId} className="relative px-5 md:px-6 py-5 md:py-7 hairline min-w-0">
      {accent && <span className="accent-bar absolute top-0 left-0" />}
      <div className="label-caps truncate">{label}</div>
      <div className={`kpi-num mt-2 ${numCls} whitespace-nowrap overflow-hidden`}>{display}</div>
      <div className="mt-3 flex items-center justify-start gap-x-4 gap-y-1 flex-wrap min-w-0 min-h-[18px]">
        {deltas.filter((d) => d.value !== null && d.value !== undefined).map((d, i) => (
          <div key={i} className="flex items-center gap-1.5 min-w-0">
            <Delta value={d.value} />
            <span className="text-[10px] uppercase tracking-widest text-muted-foreground truncate">{d.label}</span>
          </div>
        ))}
        {sub && <span className="text-[11px] text-muted-foreground truncate">{sub}</span>}
      </div>
    </div>
  );
}
